import React, { useState } from "react";
import { Box, Container } from "@mui/material";
import BackgroundImageCst from "@components/BackgroundImageCst";
import HeroCst from "@components/HeroCst";
import ScopeFormCst from "../ScopeFormCst";
import { useFetchDetail, usePostDetail } from "@hooks/useFetchDetail";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrumb from "@components/Breadcrumb";
import { useTranslation } from "react-i18next";
import { ServicesURL, uploadFile } from "@utils/utilsApi";
import { PagesID } from "@utils/utilsConfigurations";
import { StatusEnum } from "@components/ModalConfirmsCst/types";
import ModalConfirmsCst from "@components/ModalConfirmsCst";
import AnimationFadeIn from "@components/AnimationFadeIn";
import ButtonBackPage from "@components/ButtonBackPage";

const AddScope: React.FC = () => {
  const { t } = useTranslation(["scopes-page"]);
  const { columns, actionsForForms } = useFetchDetail(
    ServicesURL.getScopes,
    undefined,
    PagesID["scopes"],
  );

  const navigate = useNavigate();

  const [openToast, setOpenToast] = useState<{
    s: StatusEnum;
    message: string;
    description?: string;
  }>();

  const { trigger: triggerScope } = usePostDetail(ServicesURL.postScopes);

  const onSubmit = async (inputForm: any) => {
    setOpenToast({ s: StatusEnum.LOADING, message: "loading" });
    const objToSend: any = {
      title: inputForm.title || null,
      sub_scopes: inputForm.sub_scopes || null,
    };

    try {
      await triggerScope(objToSend);
      setOpenToast({ s: StatusEnum.OK, message: "" });
    } catch (error) {
      setOpenToast(undefined);
      console.error(error);
    }
  };

  return (
    <AnimationFadeIn>
      <BackgroundImageCst
        customWidth={"100%"}
        customHeight={"603px"}
        image="section-scopes.jpg"
        position={"absolute"}
        fullpage={true}
      />
      <Breadcrumb />
      <Container
        maxWidth={"xxl"}
        sx={{
          position: "relative",
          zIndex: 1,
        }}
      >
        <HeroCst
          title={t("add.hero-title")}
          description={t("add.hero-description")}
        />
        {columns && (
          <Box
            sx={{
              mt: "25px",
            }}
          >
            <ScopeFormCst
              columns={columns}
              onSubmit={onSubmit}
              backButton={() => {
                navigate(-1);
              }}
              fullWidth={true}
            />
          </Box>
        )}
      </Container>
      <ModalConfirmsCst
        open={!!openToast}
        title={t("hero-title-add")}
        description={""}
        onCallBackClosed={() => {
          setOpenToast(undefined);
        }}
        status={openToast}
      />
    </AnimationFadeIn>
  );
};

export default AddScope;
